/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { getCurrentQtr } from '../../../../SharedModules/utilities/utilities';
import * as ActionTypes from './actionTypes';

const initialState = {
  isLoading: false,
  errors: [],
  selectedOption: 'Request Display Of Monthly Report',
  screenGridData: [],
  leftGridData: [],
  rightGridData: [],
  selectedRequest: {},
  lasUpdatedUserIdAndCount: 'default',
  scheduleMessage: null,
  fromDate: '',
  toDate: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_INPUT_MONTHLY:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_MONTHLY_CLAIMS_RECONCILLIATION_MONTHLY:
      return {
        ...initialState,
        selectedRequest: state.selectedRequest,
        leftGridData: state.leftGridData,
        rightGridData: state.rightGridData,
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_REQUEST_SCREEN_GRID_MONTHLY:
      return { ...state, screenGridData: action.payload };
    case ActionTypes.SET_LEFT_GRID_DATA_MONTHLY:
      return { ...state, leftGridData: action.payload };
    case ActionTypes.SET_RIGHT_GRID_DATA_MONTHLY:
      return { ...state, rightGridData: action.payload };
    case ActionTypes.SET_SELECTED_REQUEST_MONTHLY:
      return { ...state, selectedRequest: action.payload };
    case ActionTypes.SET_LAST_UPDATED_USERID_AND_COUNT_MONTHLY:
      return { ...state, lasUpdatedUserIdAndCount: action.payload };
    case ActionTypes.SET_SCHEDULE_MESSAGE_MONTHLY:
      return { ...state, scheduleMessage: action.payload };
    default:
      return state;
  }
};

export default reducer;
